import { Component } from '@angular/core';
import { ErrorService } from '../app/services/error.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {

  errorContent!: string[];
  isShowError = false;

  constructor(
    private errorService: ErrorService
  ) { }

  ngOnInit() {
    this.initializeErrors();
  }

  private initializeErrors() {
    var that = this;

    this.errorService
      .getErrors()
      .subscribe((errors) => {
        if (errors && errors.length > 0) {
          that.errorContent = errors;
          that.isShowError = true;
        }else{
          that.errorContent = [];
          that.isShowError = false;
        }
      });
  }

}
